export default __webpack_public_path__ + "static/media/aylaLogoDark.8ce22505.svg";